import React from 'react';
import { motion } from 'framer-motion';
export function HighlightSection() {
  return <section className="py-8 md:py-12 bg-white" data-id="element-126">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-128">
          <div className="inline-block bg-amber-100 px-5 py-2.5 rounded-lg border-l-4 border-amber-500" data-id="element-129">
            <p className="text-base md:text-lg font-medium text-stone-900" data-id="element-130">
              A diferença não está no talento.
            </p>
            <p className="text-base md:text-lg font-bold text-amber-700" data-id="element-131">
              Está nos detalhes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}